import { AvailabilityTime } from './availability';

export class PriceChange {
  private price?: number;
  private from?: AvailabilityTime;
  private to?: AvailabilityTime;

  constructor(price: number, from?: AvailabilityTime, to?: AvailabilityTime) {
    this.price = price;
    this.from = from;
    this.to = to;
  }

  toGenericObject() {
    return JSON.parse(JSON.stringify(this));
  }
}
